import Tabit from "tabit";

export function init() {
	const element = document.getElementById("tabs");
	const options = {
		buttonActiveClass: "c-tab-active",
	};
	if (element !== null) {
		new Tabit(element, options);
	}

  const accordionToggle = document.querySelector('.toggle-filter');

  if (accordionToggle) {
    accordionToggle.addEventListener('click', (e) => {
      e.preventDefault();

      if (accordionToggle.innerHTML === "Additional Filters +") {
        accordionToggle.innerHTML = "Additional Filters -";
      } else {
        accordionToggle.innerHTML = "Additional Filters +";
      }

      const tab = document.querySelector('.filter');
      const submit = document.querySelector('.filter-closed-submit');

      tab.classList.toggle('hidden');
      submit.classList.toggle('hidden');
    });
  }
}
